/** 'TOP 차종' 섹션 노출 최소 차량 수 (미만이면 섹션 숨김) */
export const MIN_TOP_VEHICLES_TO_SHOW = 3
/** 'TOP 차종' 섹션 최대 노출 차량 수 */
export const MAX_TOP_VEHICLES = 5
